import _ from 'lodash';
import { external } from '@ubeeqo/web-api-client';
import { logger } from '@ubeeqo/web-utils';
import { PREFERRED_LOCATIONS as NAMESPACE } from '../namespaces';
import MUTATIONS from './mutations';
import ACTIONS from './actions';

const STATUS_DEFAULT = {
  IDLE: true,
  ERROR: false,
  LOADING: false,
  LOADED: false,
};

const DEFAULT_DATA = {
  custom: {
    address_street: '',
  },
  home: {
    address_street: '',
  },
  work: {
    address_street: '',
  },
};

const state = () => ({
  data: { ...DEFAULT_DATA },
  STATUS: { ...STATUS_DEFAULT },
});

const mutations = {
  [MUTATIONS.get](state, payload) {
    _.forEach(payload, (value) => {
      state.data[value.type] = value;
    });
  },
  [MUTATIONS.add](state, payload) {
    state.data[payload.type] = payload.data;
  },
  [MUTATIONS.remove](state, type) {
    _.remove(state.data, { type });
    state.data[type] = {
      address_street: '',
    };
  },
  [MUTATIONS.setStatus](state, value) {
    const states = _.keys(state.STATUS);
    if (_.includes(states, value)) {
      states.forEach((key) => {
        state.STATUS[key] = (key === value);
      });
    }
  },
  [MUTATIONS.address](state, data) {
    state.data[data.type].address = data.address;
  },
};

const actions = {
  async [ACTIONS.postPreferredLocation]({ commit }, { location, userUuid }) {
    try {
      const data = await external.userCompanyUserFavouriteLocations.postFavouriteLocation(userUuid, location);
      if (data) commit(MUTATIONS.add, { data, type: location.type });
    } catch (error) {
      commit(MUTATIONS.setStatus, 'ERROR');
      logger.message(error.message);
    }
  },
  async [ACTIONS.getPreferredLocations]({ commit }, userUuid) {
    try {
      const data = await external.userCompanyUserFavouriteLocations.getFavouriteLocations(userUuid);
      if (data) {
        commit(MUTATIONS.get, data);
      }
      commit(MUTATIONS.setStatus, 'LOADED');
    } catch (error) {
      commit(MUTATIONS.setStatus, 'ERROR');
      logger.message(error.message);
    }
  },
  async [ACTIONS.deletePreferredLocation]({ commit }, data) {
    try {
      await external.userCompanyUserFavouriteLocations.deleteFavouriteLocation(data.uuid);
      commit(MUTATIONS.remove, data.type);
    } catch (error) {
      commit(MUTATIONS.setStatus, 'ERROR');
      logger.message(error.message);
    }
  },
};

export default {
  store: {
    namespaced: true,
    state,
    mutations,
    actions,
  },
  NAMESPACE,
  MUTATIONS,
  ACTIONS,
};
